import { CookieService } from 'ngx-cookie-service';
import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ApiService } from "../services/api.service";
import { UserDataService } from "../services/user.service";
import { AppComponent } from "../app.component";

@Component({
  selector: "app-edit-dialog-box",
  templateUrl: "./edit-dialog-box.component.html",
  styleUrls: ["./edit-dialog-box.component.css"],
  providers: [
    ApiService,AppComponent // Add ApiService to the providers array
  ],
})
export class EditDialogBoxComponent {
  isError: boolean = false;
  closeIcon: string = "/assets/icons/closeIcon.svg";
  makeasAdmin: boolean = false;
  loginAdmin: boolean = false;
  makeAdminValue: string = "";
  loginAdminValue: string = "";
  refreshToken: string = "";
  
  constructor(
    public dialogRef: MatDialogRef<EditDialogBoxComponent>,
    private apiService: ApiService,
    private userDataService: UserDataService,
    private snackBar: MatSnackBar,
    private app : AppComponent,
    private cookieService :CookieService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.makeasAdmin = this.data.login_sa === "Yes" ? true : false;
    this.loginAdmin = this.data.login_access === "Yes" ? true : false;;
  }
  onCancelClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.makeAdminValue = this.data.login_sa;
    this.loginAdminValue = this.data.login_access;
  }

  updateMakeAdmin(event: any): void {
    this.makeAdminValue = event.checked ? "Yes" : "No";
  }

  updateLoginAdmin(event: any): void {
    this.loginAdminValue = event.checked ? "Yes" : "No";
  }

  onEditUser() {
    const accessToken:any = sessionStorage.getItem("accessToken");
    this.apiService
      .editData(this.data, this.makeAdminValue, this.loginAdminValue,accessToken,
        this.isError)
      .subscribe({
        next: (response) => {
          this.isError = false;
          this.openSnackBar("User Updated Successfully.");
          this.userDataService.triggerFetchUserData();
        },
        error: (error) => {
          if(error.status === 500 ) {
              this.isError = true;
              this.openSnackBar("User Updated Failed");
          }

          if (error.status === 403) {
            this.isError = true;
            this.openSnackBar("User logged out");
            this.onCancelClick()
            setTimeout(() => {
              this.app.logout();
            }, 2000);
          }
          if (error.status === 401) {
            this.isError = true;
            const refreshToken:any = sessionStorage.getItem("refreshToken");
            // Call refreshToken method
            this.apiService.refreshToken(refreshToken).subscribe({
              next: (res:any) => {
                this.refreshToken = res.data.accessToken
                sessionStorage.removeItem("accessToken");
                sessionStorage.removeItem("refreshToken");
                if (res.data.accessToken && res.data.refreshToken) {
                  sessionStorage.setItem("accessToken", res.data.accessToken);
                  sessionStorage.setItem("refreshToken", res.data.refreshToken);
                }
                this.onEditUser();
              },
              error: (refreshError) => {
                console.error("Error refreshing token:", refreshError);
                this.isError = true;
                this.openSnackBar("User logged out");
                this.onCancelClick()
                setTimeout(() => {
                  this.app.logout();
                }, 2000);
              },
            });
          }
        },
        complete: () => {
          this.dialogRef.close(this.data);
        },
      });
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, "x", {
      duration: this.isError ? 3000 : 5000,
      horizontalPosition: "center",
      verticalPosition: "top",
      panelClass: this.isError
        ? ["mat-mdc-snack-bar-container", "red"]
        : ["mat-mdc-snack-bar-container", "green"],
    });
  }
}
